import { useGetSkill } from '@entities/skill';
import { Loader, TagsInput, type TagsInputProps } from '@mantine/core';
import { getOptionsForTagsInput } from '@shared/helpers';

interface TagsInputSkillsProps extends TagsInputProps {
  placeholder?: string;
}

export const TagsInputSkills = ({
  placeholder,
  ...props
}: TagsInputSkillsProps) => {
  const { data, isLoading } = useGetSkill();

  const displayPlaceholder =
    props.value && !!props.value.length ? '' : placeholder;

  return (
    <TagsInput
      {...props}
      data={getOptionsForTagsInput(data?.map(item => item.name) ?? [])}
      placeholder={displayPlaceholder}
      rightSection={isLoading ? <Loader size='xs' /> : null}
    />
  );
};
